import { Component, Input, ViewEncapsulation } from '@angular/core';
import { AbstractControl, UntypedFormControl } from '@angular/forms';
import { MatCheckboxChange, MatCheckbox } from '@angular/material/checkbox';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'uw-select-check-all',
    templateUrl: './select-check-all.component.html',
    styleUrls: ['./select-check-all.component.scss'],
    imports: [MatCheckbox]
})
export class SelectCheckAllComponent {
  @Input()
  model: UntypedFormControl | null = null;
  @Input() values: any[] = [];

  @Input() customClass: string = '';
  
  @Input('selectAllButtonLabel')
  text = this._translateService.instant('common.select_all');

  constructor(private _translateService: TranslateService) {}

  isChecked(): boolean {
    return (
      this.model?.value &&
      this.values.length &&
      this.model.value.length === this.values.length
    );
  }

  isIndeterminate(): boolean {

    let v1 = this.model?.value;
    let v2 = this.values.length;
    let v3 = this.model?.value?.length;
    let v4 = this.model?.value?.length < this.values.length;
    let result = (
      v1 &&
      v2 &&
      v3 &&
      v4
    );

    return !!result;
  }

  toggleSelection(change: MatCheckboxChange): void {
    if (change.checked) {
      this.model?.setValue(this.values);
    } else {
      this.model?.setValue([]);
    }
  }
}
